import { type ReactElement, type ReactNode, useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/app/store";
import searchImage from "../../../../assests/Icons/search.svg"
import Button from "src/components/Button"
import Spinner from "src/components/Spinner";
import { OrderType } from "../../types/OrderType";
import { orderReset } from "../../hooks/order";
import { getOrders, getOrdersByEndUserID, getOrdersByDealerId } from "../../hooks/orders";
import OrderList from "./OrderList";
import { OrderReport } from "./OrderReport";
import { useReactToPrint } from "react-to-print";
import OrderModal from "./OrderModal";

export interface OrderMainProps {
        children?: ReactNode;
        dealerId?: string;
}

const initialOrder: OrderType = {
        Id: 0,
        OrderId: "",
        DealerName: "",
        EndUserName: "",
        EndUserInstanceName: "",
        EndUserInstanceLocationName: "",
        DealerId: 0,
        EndUserId: 0,
        EndUserInstanceId: 0,
        EndUserInstanceLocationId: 0,
        UserId: 0,
        NumberOfDoors: 0,
        SalesOrderNumber: 0,
        OrderDate: "",
}

export default function OrderManagementMain(props: OrderMainProps): ReactElement {
        const [isModalOpen, setModalOpen] = useState(false);
        const [modalTitle, setModalTitle] = useState("");
        const [selectedOrder, setOrder] = useState<OrderType | undefined>(initialOrder);
        const dispatch = useDispatch<AppDispatch>();
        const { orders, ordersLoading, ordersError } = useSelector((state: RootState) => state.orders);
        const { order, orderLoading, orderError } = useSelector((state: RootState) => state.order);
        const { dealers, dealersLoading } = useSelector((state: RootState) => state.dealers);
        const { authUser, authLoading } = useSelector((state: RootState) => state.auth);
        const { passwordProfileLoading, passwordProfiles } = useSelector((state: RootState) => state.passwordProfiles);
        const contentRef = useRef<HTMLDivElement>(null);

        const orderClicked = (event: React.MouseEvent<HTMLDivElement>) => {
                const id = parseInt(event.currentTarget.id);
                setModalOpen(true);
                setModalTitle("View Order Details");
                let order = orders.find((a) => a.Id === id);
                setOrder(order);
        }

        const Filter = () => {
        }

        const CloseModal = () => {
                setModalOpen(false);
                // if (user?.Id !== undefined) {
                //         dispatch(getUserById(user?.Id));
                // }
                dispatch(orderReset());
        }

        const PrintOrder = useReactToPrint({ contentRef });

        useEffect(() => {
                if (authUser?.UserType === "admin") {
                        dispatch(getOrders(""));
                }
                else {
                        dispatch(getOrdersByDealerId(props.dealerId));
                }
        }, [])

        return <>
                {!ordersLoading ?
                        (
                                <div className="grid grid-rows-[1fr_19fr] flex-[1_1_auto] gap-2">
                                        <div className="place-content-between flex flex-auto gap-4">
                                                <div className="flex basis-full bg-white">
                                                        <img className="p-2" src={searchImage} alt="" />
                                                        <input className="w-full hover:border-black" type="text" />
                                                </div>
                                                <Button className="basis-1/2" size="sm" type="button" buttonStyle="primary" handleClick={Filter}>Filter</Button>
                                        </div>

                                        <OrderList orderList={orders} orderClick={orderClicked} />
                                        {(isModalOpen && !passwordProfileLoading) ?
                                                <OrderModal title={modalTitle} selectedOrder={selectedOrder} isOpen={isModalOpen} onClose={CloseModal} PrintClick={PrintOrder} />
                                                :
                                                <></>
                                        }
                                        <div className="hidden">
                                                <div ref={contentRef}>
                                                        {
                                                                <OrderReport order={selectedOrder} />
                                                        }
                                                </div>
                                        </div>
                                </div>
                        )
                        :
                        <Spinner title="Loading" />
                }
        </>
}
